























import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import GJgrowEventCreateExamineeSettingSchoolClasses from '@/views/GJgrowEventCreate/ExamineeSetting/GJgrowEventCreateExamineeSettingSchoolClasses.vue';
import GJgrowEventCreateExamineeSettingStudents from '@/views/GJgrowEventCreate/ExamineeSetting/GJgrowEventCreateExamineeSettingStudents.vue';
import GVTag from '@/components/GVTag.vue';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { GPageBase } from '@/mixins';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';

@Component({
  name: 'GJgrowEventCreateExamineeSetting',
  components: {
    GVTag,
    GJgrowEventCreateExamineeSettingStudents,
    GJgrowEventCreateExamineeSettingSchoolClasses,
  },
  computed: {},
  methods: {},
})
export default class GJgrowEventCreateExamieeSetting extends Mixins(GPageBase) {
  examineeSelectionType: GEnum.ExamineeSelectionType = GEnum.ExamineeSelectionType.Class;
  async mounted() {
    this.examineeSelectionType = jgrowEventCreateModule.examineeSelectionType;
    //受検設定画面到達フラグをセット
    jgrowEventCreateModule.setVisitExamineeSettingView(true);
  }

  @Watch('examineeSelectionType')
  handleExamineeSelectionType(value: GEnum.ExamineeSelectionType) {
    jgrowEventCreateModule.setExamnieeSelectionType(value);
  }

  get isAssignStudent(): boolean {
    return jgrowEventCreateModule.isAssignStudent;
  }

  get isAssignSchoolClass(): boolean {
    return jgrowEventCreateModule.isAssignSchoolClass;
  }

  get selectionTypeStudent(): GEnum.ExamineeSelectionType {
    return GEnum.ExamineeSelectionType.Student;
  }

  get selectionTypeClass(): GEnum.ExamineeSelectionType {
    return GEnum.ExamineeSelectionType.Class;
  }

  get targetSelectedStudentCount(): number {
    return jgrowEventCreateModule.assignedExamineeStudents.length;
  }

  get selectedSchoolClassCount(): number {
    return jgrowEventCreateModule.selectedSchoolClassIDs.length;
  }

  get isValid(): boolean {
    return this.targetSelectedStudentCount > 0 || this.selectedSchoolClassCount > 0;
  }

  get evalSettingModeEdit(): boolean {
    return jgrowEventCreateModule.jgrowEventPageModeEdit;
  }

  handleClearExaminee() {
    jgrowEventCreateModule.setExamnieeSelectionType(this.examineeSelectionType);
    jgrowEventCreateModule.cleanSelectedStudents();
    if (!jgrowEventCreateModule.jgrowEventPageModeEdit) {
      jgrowEventCreateModule.resetSchoolClassSelection(schoolClassModule.gradeSchoolClasses);
    }
  }
}
